var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "title": "커뮤니티",
            "src": "/images/sub/subvisual-community.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first page-section--last",
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v("공지사항")];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "board-search-wrap"
  }, [_c('v-row', {
    staticClass: "row--xs",
    attrs: {
      "justify": "end"
    }
  }, [_c('v-col', {
    attrs: {
      "sm": "auto"
    }
  }, [_c('v-text-field', {
    staticClass: "w-md-240px",
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "placeholder": "검색어를 입력하세요."
    },
    model: {
      value: _vm.filter.searchValue,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchValue", $$v);
      },
      expression: "filter.searchValue"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "border-radius": "10px 0 10px 0"
    },
    attrs: {
      "tile": "",
      "color": "grey"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("검색")])], 1)], 1)], 1), _c('table', {
    staticClass: "board-list"
  }, [_c('thead', {
    staticClass: "d-none d-lg-table-header"
  }, [_c('tr', [_c('th', {
    staticClass: "board-list__txt d-none d-lg-table-cell",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("NO.")]), _c('th', {
    staticClass: "board-list__tit text-center",
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v("제목")]), _c('th', {
    staticClass: "board-list__txt",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("작성일")]), _c('th', {
    staticClass: "board-list__txt",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("첨부파일")])])]), _c('tbody', _vm._l(_vm.boards, function (board, idx) {
    var _board$files$;

    return _c('tr', {
      key: idx
    }, [_c('td', {
      staticClass: "board-list__txt d-none d-lg-table-cell"
    }, [_c('span', [_vm._v(_vm._s(idx + 1))])]), _c('td', {
      staticClass: "board-list__tit text-left cursor-pointer",
      on: {
        "click": function click($event) {
          return _vm.view(board._id);
        }
      }
    }, [_c('div', {
      staticClass: "text-truncate"
    }, [_c('span', [_vm._v(_vm._s(board === null || board === void 0 ? void 0 : board.subject))])])]), _c('td', {
      staticClass: "board-list__txt board-list__txt--first"
    }, [_vm._v(" " + _vm._s(_vm.$dayjs(board === null || board === void 0 ? void 0 : board.createdAt).format("YYYY-MM-DD")) + " ")]), _c('td', {
      staticClass: "board-list__txt"
    }, [_c('a', {
      attrs: {
        "href": board === null || board === void 0 ? void 0 : (_board$files$ = board.files[0]) === null || _board$files$ === void 0 ? void 0 : _board$files$.url,
        "download": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "x-small": "",
        "icon": "",
        "text": "",
        "color": "primary"
      }
    }, [_c('icon-down')], 1)], 1)])]);
  }), 0)]), _c('div', {
    staticClass: "pagination-wrap"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "5"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }